"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumStr = function (value) { return /^[0-9]+$/i.test(value); };
//# sourceMappingURL=isNumStr.js.map